import apiFetch from '../apiFetch'

export default function (token, dossierStageId) {
  return apiFetch({ endPoint: 'DossierStage/' + dossierStageId, method: 'GET', token: token })
}
